import { render } from "./versionCheck.vue?vue&type=template&id=04c6a084&scoped=true"
import script from "./versionCheck.vue?vue&type=script&lang=js"
export * from "./versionCheck.vue?vue&type=script&lang=js"

import "./versionCheck.vue?vue&type=style&index=0&id=04c6a084&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c6a084"]])

export default __exports__